export default __webpack_public_path__ + "static/media/ava-02.fe1546a1.png";